/**
 * 시설 경로(/{code}) 관제만: 중앙 게이트웨이 대신 stream_url(RTSP·현장 직접) 사용 여부.
 * 관제실(?key · 관리자)에는 적용하지 않음.
 */

export type SiteMonitorPlaybackFlags = {
  useRemotePlayback: boolean;
  siteGatewayEnabled: boolean;
  /** RTSP면 등록 미리보기와 같이 로컬/중앙 JPEG 폴링 */
  preferLocalRtspSnapshot: boolean;
};

export function resolveSiteMonitorPlaybackFlags(options: {
  useRemotePlayback: boolean;
  siteGatewayEnabled: boolean;
  siteMonitorPreferLocal?: boolean;
  /** 시설 단독 로그인(관리자 아님) */
  applySiteLocal: boolean;
}): SiteMonitorPlaybackFlags {
  if (options.applySiteLocal && options.siteMonitorPreferLocal) {
    return {
      useRemotePlayback: false,
      siteGatewayEnabled: false,
      preferLocalRtspSnapshot: true,
    };
  }
  return {
    useRemotePlayback: options.useRemotePlayback,
    siteGatewayEnabled: options.siteGatewayEnabled,
    preferLocalRtspSnapshot: false,
  };
}
